<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-1 ml-2">
          <img src="/static/img/ninjaVan.png" alt style="max-height: 50px" />
        </h3>
      </v-flex>
      <!-- <v-flex xs3 class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="onClickIsEdit, (step = 1)">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex> -->
    </v-layout>
    <!-- condition load หมุน -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- แต่ถ้าไม่ load -->
    <div v-else>
      <v-card
        color="white"
        style="padding: 24px 24px 16px;border-radius: 0px 0px 0px 0px !important;webkit-box-shadow:none !important;
    box-shadow: none !important;"
      >
        {{ $t('connect_zwiz_with_ninja') }}
        <div class="mb-2" v-if="showCancel">
          <div class="grey--text">
            {{ $t('toggle_ninja') }}
          </div>
          <div>
            <toggle-button
              class="mt-2"
              :value="setting.is_active"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="toggleStatus"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </div>
        </div>
      </v-card>
      <!-- <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('register_ninja') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('connect_ninja_express_service_for_more') }}</div>
          <v-btn depressed color="primary" :href="'#'" target="_blank" @click="step = 2">{{
            $t('register_ninja')
          }}</v-btn>

          <v-btn flat @click="step = 2">
            {{ $t('already_have_an_account') }}
          </v-btn>
          <div>
            <a href="#" target="_blank">{{ $t('how_to_use_ninja') }}</a>
          </div>
        </v-stepper-content>
        step 2 เชื่อมต่อ Zwiz กับ Ninjavan
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('connect_zwiz_with_ninja') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="mb-2" v-if="showCancel">
            <div>
              {{ $t('toggle_ninja') }}
            </div>
            <div>
              <toggle-button
                class="mt-2"
                :value="setting.is_active"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </div>
          </div>
        </v-stepper-content>
      </v-stepper> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      loading: false,
      isEdit: false,
      setting: {
        is_active: false,
        token: null
      },
      step: 1,
      showCancel: true
    }
  },
  async mounted() {
    const vm = this
    vm.getNinjaConfig()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    onClickIsEdit() {
      const vm = this
      vm.isEdit = !vm.isEdit
    },
    async getNinjaConfig() {
      const vm = this
      const data = {
        pageid: vm.selectedBot.pageid
      }
      let response = await vm.get(`ninja-van/${data.pageid}/config`)

      if (response.success) {
        vm.setting = response.result
        if (vm.setting.is_active) {
          vm.step = 2
        }
      }
    },
    async putNinjaConfig() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const data = {
          pageId: vm.selectedBot.pageid,
          body: vm.setting
        }
        let response = await vm.put(`ninja-van/${data.pageId}/config`, data.body)
        if (!response.success) {
          vm.$swal.fire({
            title: vm.$t('Unsuccessful'),
            type: 'error'
          })
        } else {
          vm.selectedBot['ninja_van_is_active'] = true
        }
        vm.$store.dispatch('loading')
        return response
      } catch (error) {
        vm.$swal.fire({
          title: vm.$t('Unsuccessful'),
          type: 'error'
        })
      }
    },
    async toggleStatus() {
      const vm = this
      vm.setting.is_active = !vm.setting.is_active
      let response = await vm.putNinjaConfig()
      if (!response.success) {
        vm.setting.is_active = !vm.setting.is_active
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NinjaManage.vue